export default "__VITE_ASSET__QSYT72bW__"